import React, { useRef } from "react";
import Select, { components } from 'react-select';
import candidateInfo_styles from './CandidateInfo.module.css';
import styled from 'styled-components';
import 'react-datepicker/dist/react-datepicker.css';
import armedForcesImage from "../resources/armed_forces.png";
import User from '../resources/gender-neutral-user-2.png';


const FlexBox = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin: 20px
`;

const CalendarDiv = styled.div`
  display: flex;
  margin-top: 10px;
  box-sizing: border-box;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
`;

export const DropdownIndicator = props => {
    return (
      <components.DropdownIndicator {...props} >
        <span style={{ fontSize: '11px', lineHeight: '4px', marginLeft: '-6px'}}>&#9660;</span>
      </components.DropdownIndicator>
    );
  };

  export const DropDownIndicatorSeperator = props => {
    return (
        <components.IndicatorSeparator {...props} >
            {/* <span style={{ fontSize: '11px', lineHeight: '4px', marginLeft: '-6px'}}>&#9660;</span> */}

        </components.IndicatorSeparator>
    );
};

const years = []
for (let i = 1990; i <= new Date().getFullYear(); i++) {
    years.push({ value: i, label: i });
}

export const customStyles = {
    control: (provided) => ({
      ...provided,
      borderRadius: '5px', // Adjust border radius as needed
      borderColor: '#93B3FC', // Border color of the select box
      minHeight: '20px',
        height: '30px',
        boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.1)',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: '#93B3FC',
      height: '5px',
      width: '5px',
       // Color of the dropdown indicator triangle
    }),
  };

  export const customLiveStyles = {
    control: (provided) => ({
      ...provided,
      borderRadius: '5px', // Adjust border radius as needed
      borderColor: '#93B3FC', // Border color of the select box
      minHeight: '50px',
        height: '50px',
        boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.1)',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: '#93B3FC',
      display: 'none',
      border: 'none'
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      display: 'none', // Hide the separator
    }),
    
  };

const CandidateInfo = (props) => {
    const [month, setMonth] = React.useState(null);
    const [year, setYear] = React.useState(null);
    const [age, setAge] = React.useState("");
    const [sexAssignedAtBirth, setSexAssignedAtBirth] = React.useState("");
    const [homeOption, setHomeOption] = React.useState("");
    const [liveOption, setLiveWithOption] = React.useState([]);
    const [incomeOption, setIncomeOption] = React.useState("");
    const [collegeAttending, setCollegeAttending] = React.useState(false);
    const [armedForces, setArmedForces] = React.useState(false);
    const [gender, setGender] = React.useState("");
    const [considerGender, setConsiderGender] = React.useState("");
    React.useEffect(() => {
        console.log("📥 Prefilling CandidateInfo from sessionStorage...");
      
        const prefill = {
          age: sessionStorage.getItem("age"),
          gender_assigned_at_birth: sessionStorage.getItem("gender_assigned_at_birth"),
          gender: sessionStorage.getItem("gender"),
          month: sessionStorage.getItem("month"),
          year: sessionStorage.getItem("year"),
          HOMETYPE_N: sessionStorage.getItem("HOMETYPE_N"),
          LiveOption: sessionStorage.getItem("LiveOption"),
          HINCOMEO_N: sessionStorage.getItem("HINCOMEO_N"),
          COLLEGE: sessionStorage.getItem("COLLEGE"),
          ArmedForcesReservesOrNationalGuard: sessionStorage.getItem("ArmedForcesReservesOrNationalGuard"),
        };
      
        let allFilled = false;
      
        if (prefill.age) setAge(prefill.age);
        if (prefill.gender_assigned_at_birth) setSexAssignedAtBirth(prefill.gender_assigned_at_birth);
        if (prefill.gender) setGender(prefill.gender);
        if (prefill.month) setMonth(Number(prefill.month));
        if (prefill.year) setYear(Number(prefill.year));
        if (prefill.HOMETYPE_N) setHomeOption(prefill.HOMETYPE_N);
      
        if (prefill.age && parseInt(prefill.age) < 18) {
          if (prefill.LiveOption) {
            const options = prefill.LiveOption.split(",").map((o) => o.trim());
            setLiveWithOption(options.map((opt) => ({ value: opt, label: opt })));
            allFilled = true;
          }
        } else {
          if (prefill.HINCOMEO_N) setIncomeOption(prefill.HINCOMEO_N);
          if (prefill.COLLEGE) setCollegeAttending(prefill.COLLEGE === "1");
          if (prefill.ArmedForcesReservesOrNationalGuard) {
            setArmedForces(prefill.ArmedForcesReservesOrNationalGuard === "1");
          }
          if (prefill.HINCOMEO_N && prefill.COLLEGE !== null) {
            allFilled = true;
          }
        }
      
        // 🚀 Auto-advance if everything required is filled
        if (allFilled) {
          console.log("✅ Prefill complete, auto-advancing…");
          props.onAllAnswered(false);
          props.setNextButton(true);
          setTimeout(() => {
            document.querySelector(".nextButton")?.click();
          }, 200);
        }
      }, []);
    React.useEffect(() => {
        if (month != null && year != null && age != null && age != "" && sexAssignedAtBirth != "" && gender != "" && homeOption != "" && (gender !== "Trans" || considerGender !== "")) {
            if (age < 18) {
                if (liveOption != []) {
                    // let LiveOptionString = liveOption.join(", ");
                    let LiveOptionString = ""
                    liveOption.forEach((item, index) => {
                        
                        LiveOptionString = LiveOptionString == "" ? item.value : LiveOptionString + ", " + item.value;
                    });

                    // console.log(LiveOptionString)
                    let data = {
                        month: month,
                        year: year,
                        age: parseInt(age),
                        gender_assigned_at_birth: sexAssignedAtBirth,
                        HOMETYPE_N: parseInt(homeOption),
                        LiveOption: LiveOptionString,
                        HINCOMEO_N: 98,
                        gender: gender == "Trans" ? considerGender : gender,
                        COLLEGE: 98,
                        ArmedForcesReservesOrNationalGuard: 98
                    }
                    props.setCandidateData(data);
                    props.setNextButton(true);
                    props.onAllAnswered();
                } else {
                    props.setNextButton(false);
                }
            } else {
                if (incomeOption != "") {
                    let data = {
                        month: month,
                        year: year,
                        age: parseInt(age),
                        gender_assigned_at_birth: sexAssignedAtBirth,
                        HOMETYPE_N: parseInt(homeOption),
                        LiveOption: "",
                        HINCOMEO_N: parseInt(incomeOption),
                        gender: gender == "Trans" ? considerGender : gender,
                        COLLEGE: (collegeAttending ? 1 : 0),
                        ArmedForcesReservesOrNationalGuard: (armedForces ? 1 : 0)
                    }
                    props.setCandidateData(data);
                    props.setNextButton(true);
                    props.onAllAnswered(false);
                } else {
                    props.setNextButton(false);
                }
        }
    } else {
            props.setNextButton(false);
        }
    }, [month, year, age, sexAssignedAtBirth, homeOption, liveOption, incomeOption, gender, considerGender ]);


    const homeOptions = {
        1: "In my own home or apartment",
        2: "In a relative’s home",
        3: "In a group home",
        4: "In campus/dormitory housing",
        5: "In a foster home",
        6: "Homeless or in a shelter",
        7: "Other"
    }

    const liveWithOptions = {
        "LIVE_ALONE": 'Alone',
        "LIVE_PARENTS": 'With parents',
        "LIVE_REL": 'With relatives other than parents',
        "LIVE_FOSTER": 'With a foster family',
        "LIVE_RM": 'With roommates',
        "LIVE_OTHER": 'Other',
    }

    const liveOptionsMultiple = [
        {
            value: 'LIVE_ALONE',
            label: 'Alone'
        },
        {
            value: 'LIVE_PARENTS',
            label: 'With parents'
        },
        {
            value: 'LIVE_REL',
            label: 'With relatives other than parents'
        },
        {
            value: 'LIVE_FOSTER',
            label: 'With a foster family'
        },
        {
            value: 'LIVE_RM',
            label: 'With roommates'
        },
        {
            value: 'LIVE_OTHER',
            label: 'Other'
        }
    ]

    const incomeOptions = {
        1: '$0–$10,000',
        2: '$10,001–$30,000',
        3: '$30,001–$50,000',
        4: '$50,001–$70,000',
        5: 'More than $70,000',
        98: 'I do not wish to answer'
    }

    const months = [
        { value: 1, label: 'January' },
        { value: 2, label: 'February' },
        { value: 3, label: 'March' },
        { value: 4, label: 'April' },
        { value: 5, label: 'May' },
        { value: 6, label: 'June' },
        { value: 7, label: 'July' },
        { value: 8, label: 'August' },
        { value: 9, label: 'September' },
        { value: 10, label: 'October' },
        { value: 11, label: 'November' },
        { value: 12, label: 'December' }
    ]

    const genders = [
        { value: 'Male', label: 'Male' },
        { value: 'Female', label: 'Female' },
        { value: 'Trans', label: 'Trans' },
        { value: 'Non-binary', label: 'Non-binary' },
        { value: 'Other', label: 'Other' },
        { value: 'No answer', label: 'Do not wish to answer' }
    ]

    const transgenderOptions = [
        { value: 'Transgender, male to female', label: 'Transgender, male to female' },
        { value: 'Transgender, female to male', label: 'Transgender, female to male' },
        { value: 'Transgender, gender nonconforming', label: 'Transgender, gender nonconforming'}
    ]

    const sexes = [
        { value:'M', label: 'Male' },
        { value: 'F', label: 'Female' }
    ]

    const handleLiveOptionChange = (value) => {
        let newliveOption = [...liveOption]
        if (newliveOption.includes(value)) {
            newliveOption = newliveOption.filter(item => item !== value)
        } else {
            newliveOption.push(value)
        }
        setLiveWithOption(newliveOption);

    }

    /* console.log(month, year, age, gender, sexAssignedAtBirth, homeOption, liveOption, incomeOption, collegeAttending, armedForces) */
    
    return (
        <>
          <FlexBox style={{ marginRight: '5px', justifyContent: 'space-between' }}>
            <div className={candidateInfo_styles.main}>
              <h2 className={candidateInfo_styles.mainWelcome}>Hey there! Tell us about yourself:</h2>
              <div
                style={{
                  margin: '20px 0 10px 0',
                  color: props.showUnanswered && (month == null || year == null) ? 'red' : 'black'
                }}
              >
                What is your birth month and year ?
              </div>
              <FlexBox style={{ justifyContent: 'flex-start', alignItems: 'center', margin: '0' }}>
                <div style={{ alignItems: 'center', margin: '0', marginRight: '20%' }}>
                  <Select
                    options={months}
                    components={{ DropdownIndicator }}
                    styles={customStyles}
                    placeholder="Month"
                    value={months.find((m) => m.value === month) || null}
                    onChange={(op) => setMonth(op.value)}
                    isSearchable={false}   // 👈 disables text input, prevents keyboard
                  />
                </div>
                <div style={{ alignItems: 'center', margin: '0' }}>
                  <Select
                    options={years}
                    components={{ DropdownIndicator }}
                    styles={customStyles}
                    placeholder="Year"
                    value={years.find((y) => y.value === year) || null}
                    onChange={(op) => setYear(op.value)}
                    isSearchable={false}   // 👈 disables text input, prevents keyboard
                  />
                </div>
              </FlexBox>
              <FlexBox style={{ justifyContent: 'space-between', alignItems: 'center', margin: '0' }}>
                <div
                  className={candidateInfo_styles.birthdateDiv}
                  style={{ marginTop: '10px', color: props.showUnanswered && (age == null || age == '') ? 'red' : 'black' }}
                >
                  What is your age ?
                </div>
                <CalendarDiv>
                  <input
                    type="number"
                    min="16"
                    max="25"
                    className={candidateInfo_styles.ageInput}
                    placeholder="Age"
                    value={age}
                    onChange={(e) => setAge(e.target.value)}
                    style={{ width: '130px' }}
                    isSearchable={false}   // 👈 disables text input, prevents keyboard
                  />
                </CalendarDiv>
              </FlexBox>
      
              <FlexBox
                style={{
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  margin: '15px 0',
                  color: props.showUnanswered && gender == '' ? 'red' : 'black'
                }}
              >
                <div className={candidateInfo_styles.birthdateDiv}>Gender</div>
                <Select
                  options={genders}
                  components={{ DropdownIndicator }}
                  styles={customStyles}
                  placeholder="Gender"
                  value={genders.find((g) => g.value === gender) || null}
                  onChange={(op) => setGender(op.value)}
                  isSearchable={false}   // 👈 disables text input, prevents keyboard
                />
              </FlexBox>
      
              {gender === 'Trans' && (
                <FlexBox
                  style={{
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    margin: '15px 0',
                    color: props.showUnanswered && considerGender == '' ? 'red' : 'black'
                  }}
                >
                  <div className={candidateInfo_styles.birthdateDiv}>Do you consider yourself to be?</div>
                  <Select
                    options={transgenderOptions}
                    components={{ DropdownIndicator }}
                    styles={customStyles}
                    placeholder="Gender Identity"
                    value={transgenderOptions.find((t) => t.value === considerGender) || null}
                    onChange={(op) => setConsiderGender(op.value)}
                    isSearchable={false}   // 👈 disables text input, prevents keyboard
                  />
                </FlexBox>
              )}
      
              <FlexBox
                style={{
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  margin: '15px 0',
                  color: props.showUnanswered && sexAssignedAtBirth == '' ? 'red' : 'black'
                }}
              >
                <div className={candidateInfo_styles.birthdateDiv}>Sex Assigned at Birth</div>
                <Select
                  options={sexes}
                  components={{ DropdownIndicator }}
                  styles={customStyles}
                  placeholder="Sex Assigned at Birth"
                  value={sexes.find((s) => s.value === sexAssignedAtBirth) || null}
                  onChange={(op) => setSexAssignedAtBirth(op.value)}
                  isSearchable={false}   // 👈 disables text input, prevents keyboard
                />
              </FlexBox>
            </div>
      
            <div className={candidateInfo_styles.userImageDiv}>
              <img className={candidateInfo_styles.userImage} src={User}></img>
            </div>
          </FlexBox>
      
          <div
            className={candidateInfo_styles.stayDiv}
            style={{ color: props.showUnanswered && homeOption == '' ? 'red' : 'black' }}
          >
            <div className={candidateInfo_styles.stayText}>Describe where you live </div>
            <div id="selectDiv1" style={{ height: '100%' }}>
              <div className={candidateInfo_styles.triangle}></div>
              <select
                value={homeOption}
                onChange={(e) => setHomeOption(e.target.value)}
                className={candidateInfo_styles.selectBox}
              >
                <option value=""></option>
                {Object.keys(homeOptions).map((key) => (
                  <option key={key} value={key}>
                    {homeOptions[key]}
                  </option>
                ))}
              </select>
            </div>
          </div>
      
          {age < 18 && age != '' ? (
            <div style={{ display: 'flex', flexDirection: 'column', color: props.showUnanswered && liveOption == '' ? 'red' : 'black' }}>
              <div className={candidateInfo_styles.incomeText}>Who do you live with ? </div>
              <div>
                <div>
                  <Select
                    options={liveOptionsMultiple}
                    styles={customLiveStyles}
                    placeholder="Live With ?"
                    value={liveOption}
                    onChange={(op) => setLiveWithOption(op)}
                    isMulti
                  />
                </div>
              </div>
            </div>
          ) : null}
      
          {age > 17 ? (
            <FlexBox>
              <div className={candidateInfo_styles.birthdateDiv}>Are you currently attending college ? </div>
              {collegeAttending ? (
                <FlexBox>
                  <div onClick={() => setCollegeAttending(false)} className={candidateInfo_styles.yesDiv}>
                    <div className={candidateInfo_styles.yesBigDiv}></div>
                    <div className={candidateInfo_styles.yesSmallDiv}></div>
                  </div>
                  <div style={{ marginLeft: '10px' }}>
                    <p>Yes</p>
                  </div>
                </FlexBox>
              ) : (
                <FlexBox>
                  <div style={{ marginRight: '10px' }}>
                    <p>No</p>
                  </div>
                  <div onClick={() => setCollegeAttending(true)} className={candidateInfo_styles.noDiv}>
                    <div className={candidateInfo_styles.noBigDiv}></div>
                    <div className={candidateInfo_styles.noSmallDiv}></div>
                  </div>
                </FlexBox>
              )}
            </FlexBox>
          ) : null}
      
          {age > 17 ? (
            <div style={{ paddingLeft: '10px' }}>
              <div className={candidateInfo_styles.armedForcesText}>
                Have you ever served in the Armed Forces, the Reserves, or the National Guard?
              </div>
              <FlexBox style={{ margin: '10px 20px' }}>
                {armedForces ? (
                  <FlexBox>
                    <div onClick={() => setArmedForces(false)} className={candidateInfo_styles.yesDiv} style={{ width: '50px', marginLeft: 'auto' }}>
                      <div className={candidateInfo_styles.yesBigDiv}></div>
                      <div className={candidateInfo_styles.yesSmallDiv}></div>
                    </div>
                    <div style={{ marginLeft: '10px' }}>
                      <p>Yes</p>
                    </div>
                  </FlexBox>
                ) : (
                  <FlexBox>
                    <div style={{ marginRight: '10px' }}>
                      <p>No</p>
                    </div>
                    <div onClick={() => setArmedForces(true)} className={candidateInfo_styles.noDiv} style={{ marginRight: '0', width: '50px', marginLeft: 'auto' }}>
                      <div className={candidateInfo_styles.noBigDiv}></div>
                      <div className={candidateInfo_styles.noSmallDiv}></div>
                    </div>
                  </FlexBox>
                )}
              </FlexBox>
            </div>
          ) : null}
      
          {age > 17 ? (
            <div style={{ display: 'flex', flexDirection: 'column', color: props.showUnanswered && incomeOption == '' ? 'red' : 'black' }}>
              <div className={candidateInfo_styles.incomeText}>
                Think about the household members who live with you right now. About how much income have you and your
                family members made in the last year before taxes? (Include child support and cash payments from the
                government—for example, welfare [TANF], SSI, or unemployment compensation.)
              </div>
      
              <div className={candidateInfo_styles.incomeDiv}>
                <div className={candidateInfo_styles.triangle} style={{ height: '100%' }}></div>
                <div style={{ width: '95%' }}>
                  <select
                    value={incomeOption}
                    onChange={(e) => setIncomeOption(e.target.value)}
                    className={candidateInfo_styles.selectBox}
                  >
                    <option value=""></option>
                    {Object.keys(incomeOptions).map((key) => (
                      <option key={key} value={key}>
                        {incomeOptions[key]}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          ) : null}
        </>
      );
                    }
                    export default CandidateInfo;